
  var _styles = {
  "headTag": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "paddingTop": "0.04rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.04rem",
    "paddingLeft": "0.16rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "headTagImg": {
    "height": "0.42667rem",
    "position": "absolute",
    "top": 0,
    "left": 0,
    "display": "flex",
    "flexDirection": "row"
  },
  "headTagText": {
    "fontSize": "0.26667rem",
    "fontFamily": "PingFang SC"
  }
};



  module.exports = _styles;
  